export const DRAMA_MAIL_BOX = 'dramatik@koda.dk';
